export const ReferenzKultur = () => {
  return (
    <svg
      //width="37.333405mm"
      //height="26.356344mm"
      version="1.1"
      viewBox="0 0 4949.1814 3132.1453"
      xmlns="http://www.w3.org/2000/svg"
      className="navicons"
    >
      <defs></defs>
      <g id="Ebene_x0020_1" transform="translate(-8373.7955,-11642.855)">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <g id="_1027795584" style={{ fill: '#ffd7c8', fillOpacity: '1' }}>
          <path
            className="fil0"
            d="m 13163,13302 c 45,-32 52,-8 106,-121 104,-215 50,-372 -96,-521 -78,-79 -171,-165 -209,-273 -89,-252 -8,-343 -33,-390 -51,16 -59,91 -120,167 -17,21 -20,34 -35,58 -50,82 -100,152 -152,229 -157,232 -292,458 -444,691 -104,157 -414,576 -462,665 -15,-29 -19,-70 -38,-103 -77,-134 -288,-297 -457,-258 -105,24 -114,62 -112,175 3,148 109,330 181,395 l 169,118 c 101,43 133,-38 170,-94 l 469,-682 c 48,-61 78,-109 119,-169 l 339,-525 c 40,36 46,83 155,159 91,65 275,152 357,262 31,42 66,97 73,154 7,50 2,45 20,63 z"
            id="path7"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 9398,13347 c -75,-25 -104,-32 -171,-68 -25,-14 -160,-110 -116,-13 9,21 84,129 99,148 79,99 187,148 284,207 135,81 371,274 410,297 19,11 -11,-1 17,7 -19,-21 -17,-29 -38,-49 -16,-15 -26,-22 -47,-39 -32,-26 -64,-44 -96,-73 -160,-147 -466,-262 -559,-457 55,25 264,132 318,108 -10,-31 -6,-28 -28,-51 -124,-130 -136,-151 -315,-252 -20,-11 -32,-21 -51,-34 -32,-20 -17,0 -36,-40 -14,-29 -34,-75 -46,-114 -43,-144 -107,-357 -166,-487 -120,-265 -125,-267 -308,-496 -13,-17 -22,-31 -38,-47 -26,-26 -23,-14 -36,-44 65,9 242,103 311,134 215,93 235,70 449,211 48,31 79,67 116,105 39,39 69,70 104,115 127,165 142,152 262,390 51,101 84,199 129,303 60,137 184,322 189,471 2,60 22,133 20,181 l -566,-897 c -42,-55 -178,-239 -248,-239 -5,67 105,228 136,284 71,125 63,127 155,269 57,88 99,176 153,270 54,96 84,180 133,281 51,106 100,181 151,273 56,101 101,163 169,246 57,72 177,322 222,413 49,98 44,113 93,115 16,-50 -10,-82 -24,-133 -14,-46 -21,-80 -37,-124 -64,-176 -101,-288 -180,-464 -17,-39 -32,-73 -52,-109 -33,-57 -34,-42 -42,-118 -5,-45 -17,-98 -23,-139 -6,-56 -5,-95 -9,-151 -6,-83 -158,-354 -196,-448 -91,-219 -180,-451 -334,-631 -300,-352 -319,-362 -754,-533 -123,-48 -204,-107 -337,-144 -64,-18 -94,-32 -91,49 29,26 52,44 83,76 28,29 48,56 74,87 49,56 93,121 139,183 75,103 157,286 206,429 53,155 95,327 164,471 21,43 44,42 89,72 95,64 132,45 269,199 z m -134,-701 c 45,26 212,271 257,338 202,301 271,401 460,725 38,67 69,126 105,192 34,60 88,136 104,205 -153,-42 -88,-3 -227,-218 l -365,-676 c -39,-65 -80,-113 -117,-180 l -193,-331 c -11,-20 -15,-36 -24,-55 z"
            id="path9"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 11555,13259 c -51,-57 -93,-140 -127,-235 -57,-158 -41,-139 -6,-293 93,-401 40,-429 72,-656 125,9 319,54 421,99 152,66 263,90 389,143 -15,138 -180,446 -270,570 -68,94 -100,175 -186,236 -67,47 -194,118 -293,136 z m -1000,-1319 c 129,-12 276,0 408,-7 134,-7 268,-15 412,-16 56,289 41,866 -143,1149 -15,23 -28,35 -37,57 -43,-43 -141,-66 -268,-190 -105,-103 -127,-125 -193,-264 -54,-111 -92,-205 -130,-327 -24,-78 -58,-313 -49,-402 z m 59,-66 c -134,18 -139,85 -109,296 19,134 32,232 84,347 99,223 139,305 290,473 19,21 24,34 46,55 23,20 214,187 265,156 34,-20 -17,-28 35,-75 45,-41 105,-131 127,-178 9,94 34,175 68,245 63,126 90,140 171,129 9,-16 8,-10 -2,-35 63,-7 135,-30 185,-52 69,-29 90,-44 140,-88 134,-119 302,-400 370,-562 23,-55 51,-109 68,-169 12,-41 7,-53 31,-87 22,-32 21,-47 11,-94 -30,-18 -168,-46 -219,-59 -202,-51 -430,-164 -684,-125 -10,-46 -14,-96 -24,-141 -13,-58 -32,-52 -47,-102 z"
            id="path11"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 10492,13231 c 26,29 178,268 187,299 -52,16 -72,43 -119,57 -57,-105 -121,-208 -178,-321 z m -733,-1154 c -25,-62 -64,-136 -93,-194 -16,-32 -96,-160 -80,-194 37,-9 74,26 93,45 29,27 146,230 165,275 l 200,393 c 20,33 37,58 56,96 l 307,582 c 16,33 36,62 51,96 l -108,38 c -30,-65 -76,-118 -107,-181 -31,-63 -66,-122 -101,-187 -69,-130 -334,-651 -383,-769 z m -217,-378 c 3,89 447,973 514,1106 90,179 192,341 288,516 46,86 96,180 147,259 25,39 44,102 113,77 l 131,-63 c 12,-134 10,-127 -90,-294 -158,-264 -292,-502 -434,-777 l -291,-513 c -208,-314 -185,-227 -227,-281 -21,-27 -19,-34 -46,-56 -37,-29 -107,-60 -105,26 z"
            id="path13"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 10943,13891 c -30,-88 -84,-166 -147,-209 -258,-170 -179,319 66,594 140,158 230,142 354,180 38,11 94,39 120,26 -37,-48 -66,-40 -113,-76 -24,-18 -27,-27 -50,-43 -27,-19 -32,-16 -42,-59 43,3 77,16 105,3 15,-73 -21,-28 -90,-86 -138,-115 -136,-135 -203,-330 z"
            id="path15"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 10944,12582 c 55,26 124,108 190,60 l -38,129 c -1,-1 -4,-6 -5,-4 z m 179,252 c 24,-43 38,-108 52,-165 21,-84 72,-198 72,-198 4,-16 5,-18 -12,-25 -36,-13 -50,10 -64,33 -29,48 -63,79 -89,122 -90,-24 -149,-100 -226,-123 -25,35 0,51 0,51 7,11 126,160 173,234 25,40 37,74 94,71 z"
            id="path17"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 11720,12792 c 19,27 34,64 41,101 -127,-27 -39,-43 -256,-30 36,-9 130,-79 215,-71 z m -271,82 c 123,34 140,-13 266,58 17,10 183,151 119,-77 -38,-136 -82,-102 -126,-112 -30,-6 -23,-13 -66,-5 -75,14 -179,80 -193,136 z"
            id="path19"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 11871,12474 c 36,28 201,81 254,62 14,-72 -36,-67 -93,-72 l -126,-8 c -42,7 -16,-3 -35,18 z"
            id="path21"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 11502,12354 c 10,45 53,59 99,74 25,8 116,47 136,25 62,-64 -199,-99 -235,-99 z"
            id="path23"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 11079,12191 c 28,31 70,15 117,10 57,-5 92,16 129,2 -5,-34 -3,-31 -45,-39 -39,-7 -133,-2 -176,12 z"
            id="path25"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 10714,12208 c 30,19 173,-11 209,-23 -11,-23 -5,-23 -49,-21 -35,1 -138,20 -160,44 z"
            id="path27"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
        </g>
      </g>
    </svg>
  );
};
